exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-agenda-[id]-index-js": () => import("./../../../src/pages/agenda/[id]/index.js" /* webpackChunkName: "component---src-pages-agenda-[id]-index-js" */),
  "component---src-pages-agenda-[id]-minutes-js": () => import("./../../../src/pages/agenda/[id]/minutes.js" /* webpackChunkName: "component---src-pages-agenda-[id]-minutes-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

